import TitleSection from './TitleSection'
import ListSection from './ListSection'
import BlogFeed from './BlogFeed'
import ExpansionList from './ExpansionList'
import CarouselSection from './CarouselSection'

export const sectionMaps = {
    TitleSection: TitleSection,
    ListSection: ListSection,
    BlogFeed: BlogFeed,
    ExpansionList: ExpansionList,
    CarouselSection: CarouselSection
}

export default sectionMaps